import { render, staticRenderFns } from "./ProgramConcept.vue?vue&type=template&id=79095742&scoped=true"
import script from "./ProgramConcept.vue?vue&type=script&lang=js"
export * from "./ProgramConcept.vue?vue&type=script&lang=js"
import style0 from "./ProgramConcept.vue?vue&type=style&index=0&id=79095742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79095742",
  null
  
)

export default component.exports